import { CardInvoiceStyle } from '@features/components/CaseCard/Blocks/Invoice/constants';
import { CardInvoices } from '@features/components/CaseCard/Blocks/Invoice/Invoice';
import { gapHeight, invoicesHeight } from '../../constants';
import { BaseCaseCard, BaseCaseCardProps } from './BaseCaseCard';

export const CaseCardWithInvoice = ({ caseData, onClick }: BaseCaseCardProps) => {
  const { invoices, caseId } = caseData;

  return (
    <BaseCaseCard extraHeight={invoices.length ? invoicesHeight + gapHeight : 0} caseData={caseData} onClick={onClick}>
      <CardInvoices invoices={invoices} caseId={caseId} style={CardInvoiceStyle.base} />
    </BaseCaseCard>
  );
};
